import { Fragment } from 'react';
import { Link } from 'react-router-dom';

/** Trilha visível. O mesmo caminho vai em `BreadcrumbList` no JSON-LD da rota. */
export function Breadcrumbs({ items }: { items: { name: string; path?: string }[] }) {
  return (
    <nav className="seo-crumbs" aria-label="Você está em">
      {items.map((item, index) => (
        <Fragment key={`${item.name}-${index}`}>
          {index > 0 && <span aria-hidden>/</span>}
          {item.path && index < items.length - 1 ? (
            <Link to={item.path}>{item.name}</Link>
          ) : (
            <span aria-current={index === items.length - 1 ? 'page' : undefined}>{item.name}</span>
          )}
        </Fragment>
      ))}
    </nav>
  );
}
